// Fake, self-contained data for the public "Take a Peek" tour.
// NOTHING here touches the API — every name, number and shift is
// invented for the fictional tenant "Nordwind Logistics BV".

export const DEMO_COMPANY = 'Nordwind Logistics BV';
export const DEMO_WEEK = 'Week 14 · 30 Mar – 5 Apr';

export const DEMO_DAYS = ['Mon 30', 'Tue 31', 'Wed 1', 'Thu 2', 'Fri 3', 'Sat 4', 'Sun 5'];

export const DEMO_KPIS = [
  { label: 'Required hours', value: '1.284', sub: 'from this week\'s volume', tone: 'slate' },
  { label: 'Planned hours', value: '1.212', sub: '38 workers rostered', tone: 'blue' },
  { label: 'Coverage', value: '94%', sub: '−72 h vs demand', tone: 'amber' },
  { label: 'Open slots', value: '6', sub: 'Order Picking · Fri/Sat', tone: 'rose' },
];

export const DEMO_DEPARTMENTS = [
  { name: 'Inbound',        required: 268, planned: 288, head: 8 },
  { name: 'Order Picking',  required: 512, planned: 448, head: 14 },
  { name: 'Expedition',     required: 244, planned: 256, head: 7 },
  { name: 'Value Added',    required: 148, planned: 152, head: 5 },
  { name: 'Returns',        required: 112, planned: 68,  head: 4 },
];

const SHIFT = (label, tone) => ({ label, tone });
const E = null;

export const DEMO_GRID = [
  {
    dept: 'Inbound',
    rows: [
      { name: 'Ruben Oudshoorn', cells: [SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), E, E] },
      { name: 'Milou Aarsen',    cells: [SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('holiday', 'teal'), SHIFT('holiday', 'teal'), SHIFT('holiday', 'teal'), E, E] },
      { name: 'Kasper de Bruin', cells: [SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), E, SHIFT('08:00–14:00', 'blue'), E] },
    ],
  },
  {
    dept: 'Order Picking',
    rows: [
      { name: 'Sanne Vermeer',   cells: [SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), E, E] },
      { name: 'Joris Mertens',   cells: [SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), E, SHIFT('14:00–22:30', 'indigo'), SHIFT('08:00–14:00', 'blue'), E] },
      { name: 'Nadia Zandvliet', cells: [SHIFT('sick', 'rose'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), SHIFT('06:00–14:30', 'blue'), E, E] },
      { name: 'Bram de Wit',     cells: [E, SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), E, E] },
      { name: '— open slot —',   open: true, cells: [E, E, E, E, SHIFT('open · 2', 'open'), SHIFT('open · 4', 'open'), E] },
    ],
  },
  {
    dept: 'Expedition',
    rows: [
      { name: 'Femke Kuiper',    cells: [SHIFT('08:00–16:30', 'blue'), SHIFT('08:00–16:30', 'blue'), SHIFT('08:00–16:30', 'blue'), SHIFT('08:00–16:30', 'blue'), SHIFT('08:00–16:30', 'blue'), E, E] },
      { name: 'Tomasz Nowak',    cells: [SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), E, SHIFT('14:00–22:30', 'indigo'), SHIFT('14:00–22:30', 'indigo'), E, E] },
    ],
  },
];

export const DEMO_PRESENCE = [
  { name: 'Sanne Vermeer',   dept: 'Order Picking', status: 'Present',  plan: '06:00–14:30', actual: '14:30', delta: '—',        note: '' },
  { name: 'Joris Mertens',   dept: 'Order Picking', status: 'Overtime', plan: '14:00–22:30', actual: '23:45', delta: '+75 min', note: 'Late truck — 3 extra pallets' },
  { name: 'Nadia Zandvliet', dept: 'Order Picking', status: 'Sick',     plan: '06:00–14:30', actual: '—',     delta: '0 min',   note: 'Called in 05:10' },
  { name: 'Ruben Oudshoorn', dept: 'Inbound',       status: 'Present',  plan: '06:00–14:30', actual: '14:30', delta: '—',        note: '' },
  { name: 'Kasper de Bruin', dept: 'Inbound',       status: 'Early',    plan: '14:00–22:30', actual: '21:15', delta: '−75 min', note: 'Volume cleared' },
  { name: 'Femke Kuiper',    dept: 'Expedition',    status: 'Present',  plan: '08:00–16:30', actual: '16:30', delta: '—',        note: '' },
  { name: 'Tomasz Nowak',    dept: 'Expedition',    status: 'No-show',  plan: '14:00–22:30', actual: '—',     delta: '0 min',   note: 'Second time this month' },
];

export const DEMO_WORKLOAD = [
  { dept: 'Inbound',       category: 'Pallets in',   volume: '2.680', benchmark: '10,0 /h', hours: 268, rate: '9,3 /h', tone: 'ok' },
  { dept: 'Order Picking', category: 'Order lines',  volume: '25.600', benchmark: '50,0 /h', hours: 512, rate: '57,1 /h', tone: 'warn' },
  { dept: 'Expedition',    category: 'Pallets out',  volume: '2.440', benchmark: '10,0 /h', hours: 244, rate: '9,5 /h', tone: 'ok' },
  { dept: 'Value Added',   category: 'Colli',        volume: '12.330', benchmark: '83,0 /h', hours: 148, rate: '81,1 /h', tone: 'ok' },
  { dept: 'Returns',       category: 'Colli',        volume: '9.300',  benchmark: '83,0 /h', hours: 112, rate: '136,8 /h', tone: 'bad' },
];

export const DEMO_KPI_TILES = [
  { label: 'Pick rate',        value: '57,1', unit: 'lines/h', trend: '+4,2%', up: true },
  { label: 'Plan accuracy',    value: '94',   unit: '%',       trend: '+1,8%', up: true },
  { label: 'Overtime share',   value: '3,1',  unit: '%',       trend: '−0,6%', up: true },
  { label: 'Absence',          value: '5,4',  unit: '%',       trend: '+0,9%', up: false },
];

export const DEMO_ACTIONS = [
  { title: 'Returns benchmark is 65% off reality', dept: 'Returns', owner: 'D. Petrov', status: 'In progress', priority: 'High' },
  { title: 'Second pick wave starts 20 min late',  dept: 'Order Picking', owner: 'S. Vermeer', status: 'Open', priority: 'High' },
  { title: 'Label printer jams on wave 3',         dept: 'Expedition', owner: 'F. Kuiper', status: 'In progress', priority: 'Medium' },
  { title: 'Inbound dock 4 pallet staging unclear', dept: 'Inbound', owner: 'R. Oudshoorn', status: 'Closed', priority: 'Low' },
];

export const DEMO_PHONE_DAYS = [
  { d: 30, tag: '06:00', tone: 'planned' }, { d: 31, tag: '06:00', tone: 'planned' },
  { d: 1, tag: '06:00', tone: 'planned' }, { d: 2, tag: '06:00', tone: 'planned' },
  { d: 3, tag: '06:00', tone: 'planned' }, { d: 4, tag: '', tone: 'free' }, { d: 5, tag: '', tone: 'free' },
  { d: 6, tag: 'vrij', tone: 'holiday' }, { d: 7, tag: 'vrij', tone: 'holiday' }, { d: 8, tag: 'vrij', tone: 'holiday' },
  { d: 9, tag: '14:00', tone: 'planned' }, { d: 10, tag: '14:00', tone: 'planned' }, { d: 11, tag: '', tone: 'free' }, { d: 12, tag: '', tone: 'free' },
];

export const DEMO_TEAM_TODAY = [
  { name: 'Sanne Vermeer', shift: '06:00–14:30', me: true },
  { name: 'Nadia Zandvliet', shift: 'Sick', me: false },
  { name: 'Bram de Wit', shift: '14:00–22:30', me: false },
  { name: 'Joris Mertens', shift: '14:00–22:30', me: false },
];

export const DEMO_CHAT = [
  { from: 'worker', text: 'Can I swap Friday late for Saturday morning?' },
  { from: 'planner', text: 'Saturday 08:00–14:00 works — Bram takes Friday late. Approved.' },
];
